import * as transaction from './transaction';
function registerDatMaker(name, desc, secret, secondSecret) {
    return transaction.createTransactionEx({
        type: 300,
        fee: String(100 * 1e8),
        args: [name, desc],
        secret,
        secondSecret: secondSecret,
    });
}
function createDat(datName, hash, makerId, url, secret, secondSecret) {
    return transaction.createTransactionEx({
        type: 301,
        fee: String(0.1 * 1e8),
        args: [datName, hash, makerId, url],
        secret,
        secondSecret: secondSecret,
    });
}
export { registerDatMaker, createDat };
//# sourceMappingURL=dat.js.map